/////// page single project contact appears on click  //////////////


    $('.response').hide();
    $('.details-project').find('.arrow').on('click', function(){
        $('.response').slideToggle();
    });

////////////////  FAQ questions appears ////////////////////
    $('.container-answer').hide();

    $('.title-question').on('click',function(){
        $(this).next('.container-answer').slideToggle();
    });

